import { CommonModule } from '@angular/common';
import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { buildPublicExperienceStyles } from '../../../services/global.service';
import { ProductDesignTemplatePageModuleDataContent } from '../../../store/app.model';

@Component({
  selector: 'app-digital-expiration-counter',
  imports: [CommonModule],
  templateUrl: './digital-expiration-counter.component.html',
})
export class DigitalExpirationCounterComponent implements OnChanges {
  // @Input({ required: true }) content!: ProductDesignTemplatePageContent;
  @Input({ required: true }) content!: any;
  @Input({ required: true }) styles!: any;
  @Input({ required: true }) isSelectedModule!: boolean;
  @Input({ required: true }) isFirstModule!: boolean;
  @Input({ required: true }) isLastModule!: boolean;
  @Input({ required: true }) expirationValue!: any;

  items: ProductDesignTemplatePageModuleDataContent[] = [];
  titleItem: ProductDesignTemplatePageModuleDataContent | undefined;
  counterItem: ProductDesignTemplatePageModuleDataContent | undefined;
  expirationDate: string | null = null;
  daysLeftInExpiration: number = 0;
  state: 'safe' | 'alert' | 'critical' | 'unknown' = 'safe';

  ngOnChanges(changes: SimpleChanges): void {
    if (this.content) {
      if (
        'pageModuleTemplateDataContents' in this.content &&
        Array.isArray(this.content.pageModuleTemplateDataContents)
      ) {
        this.items = this.content.pageModuleTemplateDataContents;
      } else if (
        'contentItems' in this.content &&
        Array.isArray(this.content.contentItems)
      ) {
        this.items = this.content.contentItems;
      } else if (
        'components' in this.content &&
        Array.isArray(this.content.components)
      ) {
        this.items = this.content.components;
      } else {
        this.items = [];
      }
    } else {
      this.items = [];
    }

    this.titleItem = this.items.find((item) => item.type === 'text');
    this.counterItem = this.items.find((item) => item.type === 'counter');

    const rawDate =
      this.counterItem?.value?.date ?? this.expirationValue?.date ?? '';
    const dateString = typeof rawDate === 'string' ? rawDate.trim() : '';
    const hasResolvedDate = !!dateString && !dateString.includes('@');

    if (hasResolvedDate) {
      this.expirationDate = dateString;
      const expirationDate = new Date(dateString);
      const today = new Date();
      const timeDifference = expirationDate.getTime() - today.getTime();
      this.daysLeftInExpiration = Math.ceil(
        timeDifference / (1000 * 60 * 60 * 24)
      );

      const {
        safeCount = Number.MAX_SAFE_INTEGER,
        alertCount = 0,
        criticalCount = 0,
      } = this.counterItem?.value ?? {};
      const days = this.daysLeftInExpiration ?? 0;

      if (days >= safeCount) {
        this.state = 'safe';
      } else if (days >= alertCount) {
        this.state = 'alert';
      } else if (days <= criticalCount) {
        this.state = 'critical';
      } else {
        this.state = 'unknown';
      }
    } else {
      this.expirationDate = null;
      this.daysLeftInExpiration = 0;
      this.state = 'unknown';
    }
  }

  filter(array: any[] | undefined | null, column: any, value: any) {
    if (!array) return [];
    return array.filter(item => item[column] === value);
  }

  buildStyle(type: string, style: any): string {
    return buildPublicExperienceStyles(type, style);
  }
}
